export default function collectFormData<T>(e: Event): T {
  const formData = new FormData(e.target as HTMLFormElement);
  const formProps = Object.fromEntries(formData);
  return formProps as T;
}
